import React, { useEffect, useState } from "react";
import {
  Box, Typography, TextField, Button, Grid,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";

import { fetchPartnerType, updatePartnerType } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function PartnerTypeEditPage() {
  const { businessDomainId, partnerTypeId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [form, setForm] = useState({
    partnerTypeId: "",
    companyId: "",
    businessDomainId: "",
    partnerTypeName: "",
    partnerTypeDescription: "",
  });
  const [fullData, setFullData] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const d = await fetchPartnerType(partnerTypeId);
        setFullData(d);
        setForm({
          partnerTypeId: d.partnerTypeId || "",
          companyId: d.companyId || "",
          businessDomainId: d.businessDomainId || "",
          partnerTypeName: d.partnerTypeName || "",
          partnerTypeDescription: d.partnerTypeDescription || "",
        });
      } catch (e) {
        notify.apiError(e);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnerTypeId]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Preserve indicators, classificationCriterias, etc. from fullData
      const payload = { ...fullData, ...form };
      await updatePartnerType(partnerTypeId, payload);
      notify.success(t("message.update.success"));
      navigate(`/design/${businessDomainId}/partner-types/${partnerTypeId}`);
    } catch (err) {
      notify.apiError(err);
    }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {t("partnerType.edit.title")}
      </Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField
              fullWidth
              required
              multiline
              label={t("partnerType.name")}
              name="partnerTypeName"
              value={form.partnerTypeName}
              onChange={handleChange}
            />
          </Grid>

          <Grid size={12}>
            <TextField
              fullWidth
              multiline
              rows={3}
              label={t("partnerType.description")}
              name="partnerTypeDescription"
              value={form.partnerTypeDescription}
              onChange={handleChange}
            />
          </Grid>
        </Grid>

        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">
            {t("common.save")}
          </Button>
          <Button variant="outlined" onClick={() => navigate(`/design/${businessDomainId}/partner-types/${partnerTypeId}`)}>
            {t("common.cancel")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
